import React, { useState } from "react";
import { Link } from "react-router-dom";
import { upcomingEvents } from "../content/events";

// Remember a dismissal per-event, so a new upcoming event shows the banner
// again rather than staying hidden forever.
const STORAGE_PREFIX = "event-banner-dismissed:";

function SiteBanner() {
  // Promote the soonest upcoming event (events are authored in date order).
  const event = upcomingEvents[0];
  const storageKey = event ? `${STORAGE_PREFIX}${event.slug}` : "";

  const [dismissed, setDismissed] = useState(() => {
    if (!event) {
      return true;
    }
    try {
      return localStorage.getItem(storageKey) === "1";
    } catch {
      return false;
    }
  });

  if (!event || dismissed) {
    return null;
  }

  function dismiss() {
    setDismissed(true);
    try {
      localStorage.setItem(storageKey, "1");
    } catch {
      /* localStorage unavailable — dismiss for this session only */
    }
  }

  return (
    <div className="site-banner">
      <Link className="site-banner-link" to={`/events#${event.slug}`}>
        <span className="site-banner-tag">Upcoming event</span>
        <span className="site-banner-text">
          {event.title} · {event.dateLabel}
        </span>
        <span className="site-banner-cta">Read more →</span>
      </Link>
      <button
        type="button"
        className="site-banner-close"
        onClick={dismiss}
        aria-label="Dismiss announcement"
      >
        ×
      </button>
    </div>
  );
}

export default SiteBanner;
